// Sin un espacio en los cierres de bloque, «Hola</p><p>mundo» daría «Holamundo».
const BLOCK_END = /<\/(p|div|li|h[1-6]|blockquote|tr)>|<br\s*\/?>/gi;

/**
 * Texto plano de un HTML de autor (editor, comentarios del Muro). `DOMParser` crea un documento
 * inerte: no carga imágenes ni ejecuta un `onerror` (el `stripHtml` de `utils` sí, con `innerHTML`)
 * y, a diferencia del de `strings`, no confunde un `&lt;` escrito por el usuario con una etiqueta.
 */
export function htmlToText(html?: string | null): string {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html.replaceAll(BLOCK_END, '$& '), 'text/html');
  return (doc.body.textContent ?? '').replaceAll(/\s+/g, ' ').trim();
}
